import { get } from '../utils/api';

export default class WaitlistConfigurationService {
  /**
   * Will retrieve the waitlist configuration for a specific property
   * ---
   * @param {string} propertyId
   * @param {Object} options
   * @returns
   */
  getWaitlistConfigurationByPropertyId(
    propertyId: string,
    options?: Object,
  ): any {
    return get(`/waitlist-configurations/property/${propertyId}`, options);
  }
}
